<template>
    <div class="w-100"
         v-bind:class="{'max-content-width':store.step!=='adContent','max-full-width':store.step==='adContent'}"
         v-if="store.step!=='intro' && store.step!=='thank-you' && store.step!=='terms' && store.step!=='privacy'">
        <div class="w-100 d-block">
            <ul class="steps list-inline d-flex justify-content-center no-margin px-4">
                <li class="list-inline-item ">
                    <a class="menu-item menu-visited" href="https://www.ohtulehtkirjastus.ee/" target="_blank">
                        ÕHTULEHT KIRJASTUS AS Narva mnt. 13, Tallinn, Eesti
                    </a> |
                    <a class="menu-item menu-visited" href="https://www.ohtulehtkirjastus.ee/kontakt/" target="_blank">
                        {{ $t('kontakt') }}
                    </a> |
                    <a class="menu-item menu-visited" href="https://www.ohtulehtkirjastus.ee/wp-content/uploads/Kuulutuste_hinnakiri_2019v3.pdf" target="_blank">
                        {{ $t('hinnakiri') }}
                    </a> |
                    <a class="menu-item menu-visited" href="https://www.ohtulehtkirjastus.ee/uldtingimused/" target="_blank">
                        {{ $t('tingimused') }}
                    </a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script setup>
import { useMainStore } from '../includes/store';
const store = useMainStore();
</script>

<style scoped>
.steps {
    border: 1px solid rgba(0, 0, 0, .125);
    border-top: 0;
}
</style>